import type { LogicFilterLeaf } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { isCustomFieldValueMissing } from './resolveCustomFieldValue';

export function isCustomFieldEmpty(
  field: string | undefined,
  customFieldId: string,
  context: LogicContext,
  filter?: LogicFilterLeaf
): boolean {
  return isCustomFieldValueMissing(field, customFieldId, context, filter);
}
